import { Action } from '@ngrx/store';
import {
    Shift,
    ShiftBreakEditingPayload,
    ShiftEditingPayload,
    Stop, TourStopTracking,
    TourStopTrackingEditingPayload,
    Tour
} from '@models/*';
import { ViewContainerRef } from '@angular/core';

export class SelectReportDay implements Action {
    readonly type = ReportShiftActionTypes.SELECT_REPORT_DAY;

    constructor(public payload: string) {
    }
}

export class LoadReportShift implements Action {
    readonly type = ReportShiftActionTypes.LOAD_REPORT_SHIFT;

    constructor(public payload: string) {
    }
}

export class LoadReportShiftSuccess implements Action {
    readonly type = ReportShiftActionTypes.LOAD_REPORT_SHIFT_SUCCESS;

    constructor(public payload: { date: string, reportShift: Shift[] }) {
    }
}

export class LoadReportShiftFail implements Action {
    readonly type = ReportShiftActionTypes.LOAD_REPORT_SHIFT_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class StartShift implements Action {
    readonly type = ReportShiftActionTypes.START_SHIFT;

    constructor(public payload: { date: string, nightStay: boolean, registeredKmStart: number }) {
    }
}

export class EndShift implements Action {
    readonly type = ReportShiftActionTypes.END_SHIFT;

    constructor(public payload: { date: string, nightStay: boolean, registeredKmEnd: number, shiftId: number, timestamp: string }) {
    }
}

export class StartShiftSuccess implements Action {
    readonly type = ReportShiftActionTypes.START_SHIFT_SUCCESS;

    constructor(public payload: { date: string, nightStay: boolean, registeredKmStart: number, shiftId: number }) {
    }
}

export class StartShiftFail implements Action {
    readonly type = ReportShiftActionTypes.START_SHIFT_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class EndShiftSuccess implements Action {
    readonly type = ReportShiftActionTypes.END_SHIFT_SUCCESS;

    constructor(public payload: { date: string, nightStay: boolean, registeredKmEnd: number, shiftId: number }) {
    }
}

export class EndShiftFail implements Action {
    readonly type = ReportShiftActionTypes.END_SHIFT_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class StartShiftBreak implements Action {
    readonly type = ReportShiftActionTypes.START_SHIFT_BREAK;

    constructor(public payload: { date: string, shiftId: number }) {
    }
}

export class EndShiftBreak implements Action {
    readonly type = ReportShiftActionTypes.END_SHIFT_BREAK;

    constructor(public payload: { date: string, shiftId: number, breakId: number }) {
    }
}

export class StartShiftBreakSuccess implements Action {
    readonly type = ReportShiftActionTypes.START_SHIFT_BREAK_SUCCESS;

    constructor(public payload: { date: string, shiftId: number, breakId: number }) {
    }
}

export class StartShiftBreakFail implements Action {
    readonly type = ReportShiftActionTypes.START_SHIFT_BREAK_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class EndShiftBreakSuccess implements Action {
    readonly type = ReportShiftActionTypes.END_SHIFT_BREAK_SUCCESS;

    constructor(public payload: { date: string, shiftId: number, breakId: number }) {
    }
}

export class EndShiftBreakFail implements Action {
    readonly type = ReportShiftActionTypes.END_SHIFT_BREAK_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class StartTourStopTracking implements Action {
    readonly type = ReportShiftActionTypes.START_TOUR_STOP_TRACKING;

    constructor(public payload: {
        date: string,
        tourStop: Stop,
        tour: Tour,
        dialogInsertion: ViewContainerRef,
    }) {
    }
}

export class EndTourStopTracking implements Action {
    readonly type = ReportShiftActionTypes.END_TOUR_STOP_TRACKING;

    constructor(
        public payload: {
            date: string,
            tourStopTrackingId: number,
            previous: boolean,
        }
    ) {
    }
}

export class StartTourStopTrackingSuccess implements Action {
    readonly type = ReportShiftActionTypes.START_TOUR_STOP_TRACKING_SUCCESS;

    constructor(public payload: {
        date: string,
        shiftId: number,
        tourId: number,
        locationGeo: any,
        locationType: string,
        address: string,
        city: string,
        sitename: string,
        tourStopTrackingId: number,
        tour: any,
    }) {
    }
}

export class StartTourStopTrackingFail implements Action {
    readonly type = ReportShiftActionTypes.START_TOUR_STOP_TRACKING_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class EndTourStopTrackingSuccess implements Action {
    readonly type = ReportShiftActionTypes.END_TOUR_STOP_TRACKING_SUCCESS;

    constructor(public payload: {
        date: string,
        tourId: number,
        locationGeo: any,
        locationType: string,
        address: string,
        city: string,
        sitename: string,
        shiftId: number,
        tourStopTrackingId: number,
    }) {
    }
}

export class EndTourStopTrackingFail implements Action {
    readonly type = ReportShiftActionTypes.END_TOUR_STOP_TRACKING_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class EditShift implements Action {
    readonly type = ReportShiftActionTypes.EDIT_SHIFT;

    constructor(public payload: { editedData: ShiftEditingPayload, date: string }) {
    }
}

export class EditShiftSuccess implements Action {
    readonly type = ReportShiftActionTypes.EDIT_SHIFT_SUCCESS;

    constructor(public payload: { editedData: ShiftEditingPayload, date: string }) {
    }
}

export class EditShiftFail implements Action {
    readonly type = ReportShiftActionTypes.EDIT_SHIFT_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class EditShiftBreak implements Action {
    readonly type = ReportShiftActionTypes.EDIT_SHIFT_BREAK;

    constructor(public payload: { editedData: ShiftBreakEditingPayload, date: string, shiftId: number }) {
    }
}

export class EditShiftBreakSuccess implements Action {
    readonly type = ReportShiftActionTypes.EDIT_SHIFT_BREAK_SUCCESS;

    constructor(public payload: { editedData: ShiftBreakEditingPayload, date: string, shiftId: number }) {
    }
}

export class EditShiftBreakFail implements Action {
    readonly type = ReportShiftActionTypes.EDIT_SHIFT_BREAK_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class EditTourStopTracking implements Action {
    readonly type = ReportShiftActionTypes.EDIT_TOUR_STOP_TRACKING;

    constructor(public payload: { editedData: TourStopTrackingEditingPayload, date: string, shiftId: number }) {
    }
}

export class EditTourStopTrackingSuccess implements Action {
    readonly type = ReportShiftActionTypes.EDIT_TOUR_STOP_TRACKING_SUCCESS;

    constructor(public payload: { editedData: TourStopTrackingEditingPayload, date: string, shiftId: number }) {
    }
}

export class EditTourStopTrackingFail implements Action {
    readonly type = ReportShiftActionTypes.EDIT_TOUR_STOP_TRACKING_FAIL;

    constructor(public payload: { date: string, error: any }) {
    }
}

export class EndCurrentTourStopTracking implements Action {
    readonly type = ReportShiftActionTypes.END_CURRENT_TOUR_STOP_TRACKING;
}

export class AddTrackedActions implements Action {
    readonly type = ReportShiftActionTypes.ADD_TRACKED_ACTIONS;

    constructor(public payload: TourStopTracking) {
    }
}

export class CancelShiftUpdate implements Action {
    readonly type = ReportShiftActionTypes.CANCEL_SHIFT_UPDATE;

    constructor(public payload: { date: string }) {
    }
}

export enum ReportShiftActionTypes {
    SELECT_REPORT_DAY = 'SELECT_REPORT_DAY',
    LOAD_REPORT_SHIFT = 'LOAD_REPORT_SHIFT',
    LOAD_REPORT_SHIFT_SUCCESS = 'LOAD_REPORT_SHIFT_SUCCESS',
    LOAD_REPORT_SHIFT_FAIL = 'LOAD_REPORT_SHIFT_FAIL',
    START_SHIFT = 'START_SHIFT',
    END_SHIFT = 'END_SHIFT',
    START_SHIFT_SUCCESS = 'START_SHIFT_SUCCESS',
    START_SHIFT_FAIL = 'START_SHIFT_FAIL',
    END_SHIFT_SUCCESS = 'END_SHIFT_SUCCESS',
    END_SHIFT_FAIL = 'END_SHIFT_FAIL',
    START_SHIFT_BREAK = 'START_SHIFT_BREAK',
    END_SHIFT_BREAK = 'END_SHIFT_BREAK',
    START_SHIFT_BREAK_SUCCESS = 'START_SHIFT_BREAK_SUCCESS',
    START_SHIFT_BREAK_FAIL = 'START_SHIFT_BREAK_FAIL',
    END_SHIFT_BREAK_SUCCESS = 'END_SHIFT_BREAK_SUCCESS',
    END_SHIFT_BREAK_FAIL = 'END_SHIFT_BREAK_FAIL',
    START_TOUR_STOP_TRACKING = 'START_TOUR_STOP_TRACKING',
    END_TOUR_STOP_TRACKING = 'END_TOUR_STOP_TRACKING',
    START_TOUR_STOP_TRACKING_SUCCESS = 'START_TOUR_STOP_TRACKING_SUCCESS',
    START_TOUR_STOP_TRACKING_FAIL = 'START_TOUR_STOP_TRACKING_FAIL',
    END_TOUR_STOP_TRACKING_SUCCESS = 'END_TOUR_STOP_TRACKING_SUCCESS',
    END_TOUR_STOP_TRACKING_FAIL = 'END_TOUR_STOP_TRACKING_FAIL',
    EDIT_SHIFT = 'EDIT_SHIFT',
    EDIT_SHIFT_SUCCESS = 'EDIT_SHIFT_SUCCESS',
    EDIT_SHIFT_FAIL = 'EDIT_SHIFT_FAIL',
    EDIT_SHIFT_BREAK = 'EDIT_SHIFT_BREAK',
    EDIT_SHIFT_BREAK_SUCCESS = 'EDIT_SHIFT_BREAK_SUCCESS',
    EDIT_SHIFT_BREAK_FAIL = 'EDIT_SHIFT_BREAK_FAIL',
    EDIT_TOUR_STOP_TRACKING = 'EDIT_TOUR_STOP_TRACKING',
    EDIT_TOUR_STOP_TRACKING_SUCCESS = 'EDIT_TOUR_STOP_TRACKING_SUCCESS',
    EDIT_TOUR_STOP_TRACKING_FAIL = 'EDIT_TOUR_STOP_TRACKING_FAIL',
    END_CURRENT_TOUR_STOP_TRACKING = 'END_CURRENT_TOUR_STOP_TRACKING',
    ADD_TRACKED_ACTIONS = 'ADD_TRACKED_ACTIONS',
    CANCEL_SHIFT_UPDATE = 'CANCEL_SHIFT_UPDATE',
}

export type ReportShiftActions =
    LoadReportShift | LoadReportShiftSuccess | LoadReportShiftFail | SelectReportDay |
    StartShift | EndShift | StartShiftSuccess | StartShiftFail | EndShiftSuccess | EndShiftFail |
    StartShiftBreak | EndShiftBreak | StartShiftBreakSuccess | StartShiftBreakFail | EndShiftBreakSuccess | EndShiftBreakFail |
    StartTourStopTracking | EndTourStopTracking | StartTourStopTrackingSuccess | StartTourStopTrackingFail |
    EndTourStopTrackingSuccess | EndTourStopTrackingFail |
    EditShift | EditShiftSuccess | EditShiftFail | EditShiftBreak | EditShiftBreakSuccess | EditShiftBreakFail |
    EditTourStopTracking | EditTourStopTrackingSuccess | EditTourStopTrackingFail |
    EndCurrentTourStopTracking | AddTrackedActions |
    CancelShiftUpdate;
